/**
 * Delay in milliseconds before throttling the cursor position updates.
 */
export const AWARENESS_CURSOR_UPDATE_THROTTLE_IN_MS = 100;

/**
 * Delay in milliseconds before updating the cursor position.
 */
export const LOCAL_CURSOR_UPDATE_DEBOUNCE_IN_MS = 5;

/**
 * Delay in milliseconds before removing a collaborator from presence indicators.
 */
export const REMOVAL_DELAY_IN_MS = 5000;
